module.exports = __webpack_public_path__ + "img/banner_sample_mo.9341cbf9.jpg";